export default {
  firebase: {
    apiKey: 'AIzaSyBhFZU0SSHI-wEiUCSDW7wad5ZIS1_gkBg',
    authDomain: 'natb-prod.firebaseapp.com',
    databaseURL: 'https://natb-prod.firebaseio.com',
    projectId: 'natb-prod',
    storageBucket: 'natb-prod.appspot.com',
    messagingSenderId: '817071462654'
  }
}
